import styled from 'styled-components';

import {
    Row,
} from '@zillow/zrs-comet';

export const StyledSortableListRow = styled(Row)`
    flex-shrink: 1 !important;
`;
